import { Injectable } from '@angular/core';
import { BuildDateFilter } from '@greco/ngx-filters';

@Injectable({ providedIn: 'any' })
export class UserPerkExpiryDateFilter extends BuildDateFilter('ExpiryDateFilter', {
  label: 'Expiry Date',
  shortLabel: 'Expiry Date',
  description: '',
  properties: ['expiryDate'],
}) {}
